"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _CTAButton = _interopRequireDefault(require("./CTAButton"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var CardCTA = props => {
  if ((0, _lodash.isEmpty)(props.buttonTxt)) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "card-footer"
  }, /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
    buttonType: props.buttonType,
    label: props.buttonTxt,
    icon: props.ctaIcon,
    iconDirection: props.ctaIconDirection,
    href: props.linkUrl,
    linkAlt: props.linkAlt,
    target: props.linkTarget,
    dataId: props.ctaDataId
  }));
};
var Callout = props => {
  if ((0, _lodash.isEmpty)(props.callOut)) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null), /*#__PURE__*/_react.default.createElement("p", {
    className: "caption"
  }, props.callOut));
};
var CardFooter = props => {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(CardCTA, props), /*#__PURE__*/_react.default.createElement(Callout, props));
};
var _default = exports.default = CardFooter;